var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2929 1.29289C12.6834 0.902369 13.3166 0.902369 13.7071 1.29289L16.7071 4.29289C17.0976 4.68342 17.0976 5.31658 16.7071 5.70711L13.7071 8.70711C13.3166 9.09763 12.6834 9.09763 12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289L13.5734 6.01118C9.35347 6.23289 6 9.72482 6 14C6 18.4183 9.58172 22 14 22C18.4183 22 22 18.4183 22 14C22 12.0052 21.2684 10.1268 19.966 8.67006C19.5979 8.25834 19.6332 7.62616 20.045 7.25805C20.4567 6.88994 21.0889 6.92529 21.457 7.33701C23.0841 9.15693 24 11.5086 24 14C24 19.5228 19.5228 24 14 24C8.47715 24 4 19.5228 4 14C4 8.61352 8.25878 4.22174 13.5929 4.00814L12.2929 2.70711C11.9024 2.31658 11.9024 1.68342 12.2929 1.29289Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshOutline);
export default __webpack_public_path__ + "static/media/refresh_outline.229e6f571005262272a539443402d73e.svg";
export { ForwardRef as ReactComponent };